import * as tslib_1 from "tslib";
import { getMobileDeviceStatistics } from '../services/getMobileDeviceStatistics';
import { getCASMailbox2 } from '../services/getCASMailbox2';
import { initMobileDeviceFullStore } from '../mutators/initMobileDeviceFullStore';
export function initMobileDeviceFullOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var getCASMailbox2Response, getMobileDeviceStatisticsResponse;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCASMailbox2()];
                case 1:
                    getCASMailbox2Response = _a.sent();
                    return [4 /*yield*/, getMobileDeviceStatistics()];
                case 2:
                    getMobileDeviceStatisticsResponse = _a.sent();
                    if (!getCASMailbox2Response.ErrorMessage && !getMobileDeviceStatisticsResponse.ErrorMessage) {
                        initMobileDeviceFullStore(getMobileDeviceStatisticsResponse.MobileDeviceStatisticsCollection.MobileDevices, getCASMailbox2Response.Options);
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
            }
        });
    });
}
//# sourceMappingURL=initMobileDeviceFullOption.js.map